var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',{staticClass:"submenu-title-noDropdown",attrs:{"disabled":_vm.isGenerating},on:{"click":_vm.generateFeedbackReport}},[_c('Item',{attrs:{"icon":"messages","title":_vm.isGenerating ? 'Генерируется...' : 'Обратная связь'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }